import {
  MetamodelContextSettings,
  MetamodelReferenceTypeContext,
} from 'metamodel/types';
import { APIFieldAttributes, Metamodel } from '@ardoq/api-types';
import {
  ReferenceCompletionForReference,
  ReferenceTypeSubtitle,
  ReferenceTypeTitle,
} from './atoms';
import { BreadCrumbNavigation } from './breadCrumbNavigation/BreadCrumbNavigation';
import { FieldCompletionWidget } from './completion/FieldCompletionWidget';
import { getFieldCompletion } from './utils';
import { Box } from '@ardoq/layout';
import { type I18nLocale } from '@ardoq/i18n';

const ReferenceTypeStats = ({
  context,
  metamodel,
  nonTemplateFieldsByName,
  i18nLocale,
}: {
  context: MetamodelReferenceTypeContext & MetamodelContextSettings;
  metamodel: Metamodel;
  nonTemplateFieldsByName: Map<string, APIFieldAttributes>;
  i18nLocale: I18nLocale;
}) => {
  const { referenceTypes } = metamodel.metamodel;
  const referenceType = referenceTypes[context.id];
  const referenceFieldCompletion = getFieldCompletion(
    referenceType,
    metamodel.metamodel.dateRangeFieldMap,
    nonTemplateFieldsByName
  );
  return (
    <Box position="relative">
      <BreadCrumbNavigation
        metamodel={metamodel}
        context={context}
        nonTemplateFieldsByName={nonTemplateFieldsByName}
      />
      <Box marginTop="small">
        <ReferenceTypeTitle
          metamodel={metamodel}
          context={context}
          i18nLocale={i18nLocale}
        />
      </Box>
      <ReferenceTypeSubtitle
        fieldCompletion={referenceFieldCompletion}
        i18nLocale={i18nLocale}
      />
      <ReferenceCompletionForReference
        metamodel={metamodel}
        context={context}
        i18nLocale={i18nLocale}
      />
      <FieldCompletionWidget
        fieldCompletion={referenceFieldCompletion}
        context={context}
        metamodel={metamodel}
        i18nLocale={i18nLocale}
      />
    </Box>
  );
};

export { ReferenceTypeStats };
